import { useDrawing } from '../../../../../redux/reducer/content';
import { useUser } from '../../../../../redux/reducer/user';
import { useMemo } from 'react';

export default function useGetPrizes() {
  const {
    profile: { uid },
  } = useUser();
  const { winnersPrizes } = useDrawing();

  return useMemo(() => {
    const prizesList = [];
    for (const key in winnersPrizes) {
      const subPrizesList = winnersPrizes[key];
      prizesList.push(...subPrizesList);
    }
    return prizesList;
  }, [winnersPrizes, uid]);
}
